import {emailRegex, numberRegex, phoneRegex, textRegex} from "./regex";

export const isPhoneNumber = (phoneNumber: string): boolean => {
    return !!phoneNumber.match(phoneRegex)
}

export const isNameOrLastname = (nameOrLastname: string): boolean => {
    return !!nameOrLastname.match(textRegex)
}

export const isEmailAddress = (emailAddress: string): boolean => {
    return !!emailAddress.match(emailRegex)
}

export const includeOnlyNumber = (stringToTest: string): boolean => {
    return !!stringToTest.match(numberRegex)
}

export const isBoolean = (valueToCheck: any): boolean => {
    return typeof valueToCheck === "boolean"
}
